import api from '../api'
import { PagePermission, PagePermissionBulkPayload, MyPermissions } from '../../types/settings/pagePermissionTypes'

export const getPagePermissions = async (): Promise<PagePermission[]> => {
  const response = await api.get<PagePermission[]>('/organization/page-permissions/')
  return response.data
}

export const updatePagePermissions = async (payload: PagePermissionBulkPayload): Promise<PagePermission[]> => {
  const response = await api.put<PagePermission[]>('/organization/page-permissions/', payload)
  return response.data
}

export const getMyPermissions = async (): Promise<MyPermissions> => {
  const params: Record<string, string> = {}
  // When admin is viewing as user, pass the simulated role
  const actualRole = localStorage.getItem('role')
  const isAdmin = localStorage.getItem('is_admin')
  if (actualRole === 'user' && isAdmin === 'false') {
    params.role = 'user'
  }
  const response = await api.get<MyPermissions>('/organization/my-permissions/', { params })
  return response.data
}
